import api from '../common/api/settlement.api.js';
import EventBus from '../common/event-bus/event-bus';
import {SETTLEMENT_CONFIRMATION_MODAL_EVENT} from '../common/constants/constants';

const SET_SETTLEMENTS = 'SET_SETTLEMENTS';
const SET_SETTLEMENT = 'SET_SETTLEMENT';
const SET_STREETS = 'SET_STREETS';
const SET_STREET = 'SET_STREET';
const SET_HOUSE_NUMBERS = 'SET_HOUSE_NUMBERS';
const SET_HOUSE_NUMBER = 'SET_HOUSE_NUMBER';
const SET_IS_FORCE = 'SET_IS_FORCE';

export default {
	namespaced: true,
	state: {
		settlement: {},
		settlements: [],
		street: {},
		streets: [],
		houseNumber: '',
		houseNumbers: [],
		isForce: false
	},
	actions: {

		getAddressesOnSettlement({commit}, params) {
			return new Promise((resolve, reject) => {
				api.getAddressesOnSettlement(params).then(response => {
					commit(SET_SETTLEMENTS, response.data);
					commit(SET_STREET, {});
					commit(SET_HOUSE_NUMBER, '');
					resolve();
				}).catch(error => {
					EventBus.$emit('error');
					reject(error);
				});
			});
		},

		getStreetsByTelepulesId({commit, state}) {
			return new Promise((resolve, reject) => {
				api.getStreetsByTelepulesId(state.settlement.id).then(response => {
					commit(SET_STREETS, response.data);
					commit(SET_HOUSE_NUMBER, '');
					resolve();
				}).catch(error => {
					EventBus.$emit('error');
					reject(error);
				});
			});
		},

		changeAddress({dispatch, state}, {hazSzam, kozteruletId, kozteruletTipusId, telepulesId} = {}) {
			const params = {
				hazSzam: hazSzam == 0 || hazSzam ? hazSzam : state.houseNumber,
				kozteruletId: kozteruletId == 0 || kozteruletId ? kozteruletId : state.street.kozteruletId,
				kozteruletTipusId: kozteruletTipusId == 0 || kozteruletTipusId ? kozteruletTipusId : state.street.kozteruletTipusId,
				telepulesId: telepulesId == 0 || telepulesId ? telepulesId : state.settlement.id
			};

			return new Promise((resolve, reject) => {
				(state.isForce ? api.postForceChangeAddress(params) : api.postChangeAddress(params)).then(response => {
					dispatch('cartsStore/getCarts', {}, {root: true});
					resolve(response.data);
				}).catch(error => {
					if (error && error.response && error.response.data && error.response.data.errorCode == 'confirm_address_change') {
						EventBus.$emit(SETTLEMENT_CONFIRMATION_MODAL_EVENT.OPEN, {
							webItems: error.response.data.inCartItems,
							address: params
						});
						reject(error.response.data.errorCode);
					} else {
						EventBus.$emit('address-changed-and-its-invalid');
						EventBus.$emit('error');
						reject();
					}
				}).then(() => {
					dispatch('setIsForce', false);
				});
			});
		},

		createCartWithAddress({dispatch, state}) {
			const params = {
				hazSzam: state.houseNumber,
				kozteruletId: state.street.kozteruletId,
				kozteruletTipusId: state.street.kozteruletTipusId,
				telepulesId: state.settlement.id
			};

			return new Promise((resolve, reject) => {
				api.createCartWithAddress(params)
					.then(response => {
						dispatch('cartsStore/getCarts', {}, {root: true});
						resolve(response.data);
					})
					.catch(error => {
						console.error('Creating new cart with address failed.', {error, params});
						reject();
					});
			});
		},

		changeActiveAddress({dispatch}, params) {
			const address = {
				hazSzam: params.hazSzam,
				kozteruletId: params.kozteruletId,
				kozteruletTipusId: params.kozteruletTipusId,
				telepulesId: params.telepulesId
			};

			return new Promise((resolve, reject) => {
				api.changeActiveAddress(address)
					.then(response => {
						dispatch('cartsStore/activateCart', {id: params.id}, {root: true});
						resolve(response.data);
					})
					.catch(error => {
						console.error('Active address change failed.', {error, params});
						reject(error);
					});
			});
		},

		resetAddress({commit}) {
			commit(SET_SETTLEMENT, {});
			commit(SET_SETTLEMENTS, []);
			commit(SET_STREET, {});
			commit(SET_STREETS, []);
			commit(SET_HOUSE_NUMBER, '');
			commit(SET_HOUSE_NUMBERS, []);
		},

		setSettlement({commit}, settlement) {
			commit(SET_SETTLEMENT, settlement);
		},

		setStreet({commit}, street) {
			commit(SET_STREET, street);
			commit(SET_HOUSE_NUMBERS, street.hazSzam);
		},

		setHouseNumber({commit}, houseNumber) {
			commit(SET_HOUSE_NUMBER, houseNumber);
		},

		setIsForce({commit}, isForce) {
			commit(SET_IS_FORCE, isForce);
		}
	},
	mutations: {
		[SET_SETTLEMENTS](state, settlements) {
			state.settlements = settlements;
		},
		[SET_SETTLEMENT](state, settlement) {
			state.settlement = settlement;
		},
		[SET_STREETS](state, streets) {
			state.streets = streets;
		},
		[SET_STREET](state, street) {
			state.street = street;
		},
		[SET_HOUSE_NUMBERS](state, houseNumbers) {
			state.houseNumbers = houseNumbers;
		},
		[SET_HOUSE_NUMBER](state, houseNumber) {
			state.houseNumber = houseNumber;
		},
		[SET_IS_FORCE](state, isForce) {
			state.isForce = isForce;
		}
	}
};



// WEBPACK FOOTER //
// ../source/stores/settlement.store.js